import { requestSocialGroupDetailPromise } from 'api/SocialGroup'
import React, { useMemo, useState } from 'react'
import Form from './form'

export default function BlacklistAdd (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})

  useMemo(() => {
    if (!id) return

    requestSocialGroupDetailPromise(id).then(resp => {
      resp && setData(resp)
    })
  }, [id])

  return <Form data={data} setData={setData} {...props} />
}